/**
 * Cross-module signal that the current session has expired and the user
 * must re-authenticate. Dispatched by the refresh singleton on a refused
 * refresh; consumed by AuthProvider, which logs the operator out and
 * redirects to /login (where a notice explains the expiry).
 */
export const SESSION_EXPIRED_EVENT = "session:expired" as const;

const target = typeof EventTarget !== "undefined" ? new EventTarget() : null;

if (target === null) {
  throw new Error(
    "sessionEvents requires the EventTarget global (browser or jsdom)."
  );
}

export const sessionEvents = {
  emitExpired: (): void => {
    target.dispatchEvent(new Event(SESSION_EXPIRED_EVENT));
  },
  onExpired: (handler: () => void): (() => void) => {
    target.addEventListener(SESSION_EXPIRED_EVENT, handler);
    return () => target.removeEventListener(SESSION_EXPIRED_EVENT, handler);
  },
};
